import { getAxiosClient, makeApiRequest } from '@givelify/utils';
import { ThunkAction } from 'redux-thunk';
import { AppActions, AppState } from 'store';
import { setFingerprint, setOfficerTitles } from './actions';
import { webConfig } from 'webConfig';
import { getFingerprint, setOption } from '@thumbmarkjs/thumbmarkjs';

export const getOfficerTitles =
    (): ThunkAction<Promise<boolean>, AppState, undefined, AppActions> =>
    async (dispatch) => {
        const httpRequest = getAxiosClient({
            baseURL: webConfig.doneePortalApiUrl,
        }).get(`/titles`);
        const officersResponse = await makeApiRequest<{
            data: { id: number; name: string }[];
        }>(httpRequest);

        if (officersResponse.success && officersResponse.response) {
            const result = officersResponse.response.data.map(
                (title) => title.name,
            );
            const titles: string[] = Array.from(new Set(result));
            dispatch(
                setOfficerTitles(titles.sort((a, b) => a.localeCompare(b))),
            );
        }

        return officersResponse.success;
    };

export const loadFingerprint =
    (): ThunkAction<Promise<void>, AppState, undefined, AppActions> =>
    async (dispatch) => {
        let fingerprint = localStorage.getItem('fingerprint');
        if (!fingerprint) {
            setOption('logging', false);
            fingerprint = await getFingerprint();
            localStorage.setItem('fingerprint', fingerprint);
        }

        dispatch(setFingerprint(fingerprint));
    };
